import { Package } from "@/types/package";

export interface TimeRange {
    startDate: string;
    endDate: string;
    percentBoost: number;
    isDefault?: boolean;
}
export default function calculateAvailableCast(
    stakeInfo: Package,
    stakePool: any,
    nowTime?: number,
    calculateNotClaim?: boolean,
    itemsMissions?: TimeRange[]
) {
    console.log("🚀 ~ itemsMissions itemsMissions:", itemsMissions);
    try {
        const { block_time, token_on_block_time, block_time_withdraw_origin, percent_commission } = stakePool;
        const {
            principal,
            last_time_update,
            time_deposit,
            auto_subscribe,
            id,
            rate_usd,
            amount_interest_remaining,
            is_flexible,
        } = stakeInfo;
        const now = nowTime || new Date().getTime() / 1000;
        const data = {
            amount_user: 0,
            amount_admin: 0,
            close_time: now,
            totalClaimed: 0,
            totalNotClaimed: 0,
            id,
        };

        const itemsMissionsApplied: TimeRange[] = itemsMissions ? compoundInterestRate(itemsMissions) : [];

        let closeTime = now;

        if (!auto_subscribe) {
            const maxCloseTime = Number(time_deposit) + Number(block_time_withdraw_origin);
            closeTime = !is_flexible ? Math.min(maxCloseTime, closeTime) : closeTime;
        }

        data.close_time = closeTime;
        if (itemsMissionsApplied?.length <= 0) {
            // console.log("no halving");

            if (closeTime != 0 && closeTime > Number(last_time_update)) {
                const diff_time = closeTime - Number(last_time_update);

                const number_block = diff_time / Number(block_time);
                if (number_block > 0.0) {
                    const amount_claimed = number_block * Number(principal) * (Number(token_on_block_time) / 100);
                    data.close_time = closeTime;

                    data.totalClaimed += amount_claimed + data.totalNotClaimed;
                    data.totalNotClaimed = 0;
                }
            }
        } else {
            let lastTimeUpdate = Number(last_time_update);
            for (let i = 0; i < itemsMissionsApplied.length; i++) {
                const log = itemsMissionsApplied[i];
                const endDate = Number((new Date(log.endDate).getTime() / 1000).toFixed(0));

                if (closeTime != 0 && closeTime > Number(lastTimeUpdate)) {
                    const timeCalculate = Math.min(closeTime, endDate);
                    const diffTime = timeCalculate - Number(lastTimeUpdate);

                    const numberBlock = diffTime / Number(block_time);
                    if (numberBlock > 0.0) {
                        const amountClaimed = numberBlock * Number(principal) * (Number(log.percentBoost) / 100);

                        data.totalClaimed += amountClaimed + data.totalNotClaimed;
                        data.totalNotClaimed = 0;
                        lastTimeUpdate = timeCalculate;
                    }
                }
            }
            if (closeTime > lastTimeUpdate) {
                const diffTime = closeTime - Number(lastTimeUpdate);
                const numberBlock = diffTime / Number(block_time);
                if (numberBlock > 0.0) {
                    const amountClaimed = numberBlock * Number(principal) * Number(token_on_block_time);
                    data.totalClaimed += amountClaimed;
                }
            }
        }
        const amount_interest = amount_interest_remaining ? amount_interest_remaining : 0;
        return {
            ...data,
            availableCast: data.totalClaimed * (1 - percent_commission / 100) * Number(rate_usd) + +amount_interest,
        };
    } catch (err) {
        console.log("🚀 ~ calculateAvailableCast err:", err);
        return null;
    }
}

export function compoundInterestRate(inputs: TimeRange[]): TimeRange[] {
    // Convert string dates to timestamps and collect all unique timestamps
    const timestamps = new Set<number>();
    inputs.forEach((range) => {
        timestamps.add(new Date(range.startDate).getTime());
        timestamps.add(new Date(range.endDate).getTime());
    });

    // Sort timestamps
    const sortedTimestamps = Array.from(timestamps).sort((a, b) => a - b);
    console.log("🚀 ~ HelperService ~ compoundInterestRate ~ sortedTimestamps:", sortedTimestamps);

    // Process each time segment
    const result: TimeRange[] = [];
    for (let i = 0; i < sortedTimestamps.length - 1; i++) {
        const start = sortedTimestamps[i];
        const end = sortedTimestamps[i + 1];

        // Calculate total boost for this time segment
        let totalBoost = 0;
        inputs.forEach((range) => {
            const rangeStart = new Date(range.startDate).getTime();
            const rangeEnd = new Date(range.endDate).getTime();

            if (rangeStart <= start && rangeEnd >= end) {
                totalBoost += range.percentBoost;
            }
        });

        if (totalBoost > 0) {
            result.push({
                startDate: new Date(start).toISOString(),
                endDate: new Date(end).toISOString(),
                percentBoost: totalBoost,
            });
        }
    }

    return result;
}
